module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75cd67a9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/Ckeditor.vue
// module id = 947
// module chunks = 0